module.exports = __webpack_public_path__ + "img/uitgerolde-cinnamon-roll-deeg.0f895cdd.jpeg";